// extracted by mini-css-extract-plugin
export default {"icon":"collapse-arrow_icon__ysxG2","icon--rotated":"collapse-arrow_icon--rotated__f2eQw"};